import { call, put, select, takeLatest } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { accountBalanceSlice } from '../accountBalance';
import { securityAccountSelectedSelector } from './userSecuritiesAccounts.selectors';
import { userSecuritiesAccountsServices } from './userSecuritiesAccounts.services';
import { userSecuritiesAccountsSlice } from './userSecuritiesAccounts.slice';

const userSecuritiesAccountsWorker = function* () {
  try {
    const userSecuritiesAccounts = yield call(
      userSecuritiesAccountsServices.userSecuritiesAccounts,
    );

    yield put(
      userSecuritiesAccountsSlice.actions.userSecuritiesAccountsSucess(
        userSecuritiesAccounts,
      ),
    );

    const securityAccount = yield select(securityAccountSelectedSelector);

    const account =
      securityAccount ??
      userSecuritiesAccounts.find((el) => el.favorite === 'Y')?.account ??
      userSecuritiesAccounts[0].account;

    yield put(
      accountBalanceSlice.actions.accountBalanceRequest({
        securityAccount: account,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(
        userSecuritiesAccountsSlice.actions.userSecuritiesAccountsFailure(),
      );
  }
};

export const userSecuritiesAccountsSagas = function* () {
  yield takeLatest(
    userSecuritiesAccountsSlice.actions.userSecuritiesAccountsRequest.type,
    userSecuritiesAccountsWorker,
  );
};
